import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAuth, { ModuleTypes } from 'src/features/authorization/hooks/use-auth';

export type SubNavbarItem = {
  href: string;
  text: string;
  external?: boolean;
  module?: ModuleTypes;
};

type Props = {
  items: SubNavbarItem[];
};

const SubNavbarLink: React.FC<SubNavbarItem> = ({ href, text, external }) => {
  const { pathname } = useLocation();

  if (external) {
    return <a href={href}>{text}</a>;
  }

  return (
    <Link
      to={href}
      className={classNames('sub-navbar--link', {
        active: pathname.startsWith(href),
      })}
    >
      {text}
    </Link>
  );
};

export const SubNavbar: React.FC<Props> = ({ items }) => {
  const { checkAccess } = useAuth();

  const resolvedItems = useMemo(
    () =>
      items.filter((item) => {
        if (item.module) {
          return checkAccess(item.module).read;
        }

        return true;
      }),
    [checkAccess, items],
  );

  return (
    <div className="sub-navbar">
      <div className="sub-navbar--container">
        {resolvedItems.map((item) => (
          <SubNavbarLink key={item.href} {...item} />
        ))}
      </div>
    </div>
  );
};
